import { cloneDeep } from 'lodash';
import { PRR_FILTER_TYPE } from './PerformancePageSelectors';
import {
  checkIsAggregateRateOfReturnEligible,
  handleAccountTypeSelection
} from './PerformancePageUtils';
import { PREFILTER_ACCOUNTS } from '../Actions';
import { RECEIVED_ACCOUNTS } from '../account/AccountBalancesActions';
import { sortAccountIdsByType } from './PerformancePageReducer';
import {
  ALL_LABEL,
  APP_LABEL,
  COLLEGE_SAVINGS_LABEL,
  MUTUAL_FUND_LABEL,
  RAS_LABEL
} from 'services/Filters';
import { getSelectedAccountTypeActionForFilterType } from './PerformancePageActions';

const getPriority = (option) => {
  switch (option) {
    case ALL_LABEL:
      return 0;
    case RAS_LABEL:
      return 1;
    case APP_LABEL:
      return 2;
    case MUTUAL_FUND_LABEL:
      return 3;
    case COLLEGE_SAVINGS_LABEL:
      return 4;
    default:
      return 5;
  }
};

export const productTypeOptions = [
  RAS_LABEL,
  APP_LABEL,
  MUTUAL_FUND_LABEL,
  COLLEGE_SAVINGS_LABEL
];

export const filterProductTypeOptions = (options) =>
  options.filter((option) => productTypeOptions.includes(option));

const getAvailableOptionTypes = (accountIdsByOptionType) => {
  const filteredOptions = filterProductTypeOptions(
    Object.keys(accountIdsByOptionType).filter(
      (option) => accountIdsByOptionType[option]?.length > 0
    )
  );

  if (checkIsAggregateRateOfReturnEligible(accountIdsByOptionType)) {
    filteredOptions.unshift(ALL_LABEL);
  }

  return filteredOptions;
};

const prioritySort = (a, b) => getPriority(a) - getPriority(b);
export const getHighestPriority = (options) =>
  options.sort(prioritySort).shift();

export const getAvailableOptions = (accounts) => {
  const accountIdsByOptionType = sortAccountIdsByType(accounts);
  return getAvailableOptionTypes(accountIdsByOptionType);
};

const updatePRROnReceivedAccounts = (state, action) => {
  const rateOfReturnFilter = cloneDeep(state);
  const availableOptions = getAvailableOptions(action.accounts);

  rateOfReturnFilter.filter.label = getHighestPriority(availableOptions);
  return rateOfReturnFilter;
};

const updatePRROnPrefilterAccounts = (state, action) => {
  const rateOfReturnFilter = cloneDeep(state);
  const { filter } = rateOfReturnFilter;
  const availableOptions = getAvailableOptions(action.accounts);

  // Select default product type if the previous selection is no longer available
  if (!availableOptions.includes(filter.label)) {
    rateOfReturnFilter.filter.label = getHighestPriority(availableOptions);
  }
  return rateOfReturnFilter;
};

export const RateOfReturnFilterReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVED_ACCOUNTS:
      return updatePRROnReceivedAccounts(state, action);
    case PREFILTER_ACCOUNTS:
      return updatePRROnPrefilterAccounts(state, action);
    case getSelectedAccountTypeActionForFilterType(PRR_FILTER_TYPE):
      return handleAccountTypeSelection(state, action);
    default:
      return state;
  }
};
